import { FaGithub, FaLinkedin, FaYoutube, FaMedium , FaInstagram} from "react-icons/fa";
import { SiUdemy } from "react-icons/si";

export const SOCIAL_MEDIA_NAV = [
  { link: "https://github.com/DhanushkaSandakelum", icon: <FaGithub /> },
  {
    link: "https://www.linkedin.com/in/dhanushkasandakelum/",
    icon: <FaLinkedin />,
  },
  { link: "https://www.youtube.com/@simpleepic", icon: <FaYoutube /> },
  { link: "https://dhanushkasandakelum.medium.com/", icon: <FaMedium /> },
  { link: "https://www.instagram.com/dhanushkasandakelum.ig", icon: <FaInstagram /> },
  {
    link: "https://www.udemy.com/user/dhanushka-26/",
    icon: <SiUdemy />,
  },
];
